import React from "react";
import style from "../App.module.scss";
import { Logo } from "../components/Logo";
import ContactIframe from "../ContactIframe";
import { getMessage, Message, MessageContext } from "@messageformat/react";

const ContactForm = () => {
  const messageContext = React.useContext(MessageContext);

  return (
    <section
      className={style.pageInner}
      style={{ marginBottom: 0, minHeight: "90vh" }}
    >
      <div className={style.heading}>
        <span>
          <Message id="infoPages.contactForm.title" />
        </span>
        <h2>
          <Message id="infoPages.contactForm.description" />
        </h2>
      </div>

      <p
        style={{ marginBottom: "10px", marginTop: "40px" }}
        dangerouslySetInnerHTML={{
          __html: getMessage(messageContext, "infoPages.contactForm.enum1")(),
        }}
      />
      <p
        style={{ marginTop: "0", marginBottom: "10px" }}
        dangerouslySetInnerHTML={{
          __html: getMessage(messageContext, "infoPages.contactForm.enum2")(),
        }}
      />
      <p
        style={{ marginTop: "0" }}
        dangerouslySetInnerHTML={{
          __html: getMessage(messageContext, "infoPages.contactForm.enum3")(),
        }}
      />

      <ContactIframe />

      <Logo />
    </section>
  );
};

export default ContactForm;
